import resources from '../../resources';
export var BASE_DATA_LOADING = 'WEBSITE/BASE_DATA_LOADING';
export var BASE_DATA_LOAD_SUCCESS = 'WEBSITE/BASE_DATA_LOAD_SUCCESS';
export var BASE_DATA_LOAD_FAILED = 'WEBSITE/BASE_DATA_LOAD_FAILED';
export function loadBaseData() {
  return function (dispatch) {
    var _a;
    dispatch({
      type: BASE_DATA_LOADING
    });
    return resources.website.getBaseData((_a = process.env.HOSTNAME) !== null && _a !== void 0 ? _a : location.hostname).then(function (result) {
      dispatch({
        type: BASE_DATA_LOAD_SUCCESS,
        data: result
      });
      return result;
    }).catch(function (err) {
      dispatch({
        type: BASE_DATA_LOAD_FAILED,
        error: err
      });
      throw err;
    });
  };
}